function PeriodLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/period/${view}.vue`
    );
}

const periodRoutes = [
  /* 월정기할인권 > 일반 월정기할인권 */
  // 안내
  {
    path: '/period/info',
    name: 'periodInfo',
    component: PeriodLoadView('periodInfo'),
    meta: {
      category: ['월정기할인권', '월정기할인권 안내'],
      isLnb: true,
    },
  },

  // 월정기할인권 신청 - 주차장 리스트
  {
    path: '/period/list',
    name: 'periodList',
    component: PeriodLoadView('periodList'),
    meta: {
      category: ['월정기할인권', '월정기할인권 신청'],
      isLnb: true,
    },
  },

  // 정보입력
  {
    path: '/period/apply',
    name: 'periodApply',
    component: PeriodLoadView('periodApply'),
    meta: {
      category: ['월정기할인권', '월정기할인권 신청'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },

  // 이용현황
  {
    path: '/period/history',
    name: 'periodHistory',
    component: PeriodLoadView('periodHistory'),
    meta: {
      category: ['월정기할인권', '월정기할인권 조회/결제'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },

  // 상세
  {
    path: '/period/view',
    name: 'periodView',
    component: PeriodLoadView('periodView'),
    meta: {
      category: ['월정기할인권', '월정기할인권 조회/결제'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },

  // 월정기할인권 잔여면 조회
  {
    path: '/period/remain',
    name: 'periodRemain',
    component: PeriodLoadView('periodRemain'),
    meta: {
      category: ['월정기할인권', '월정기할인권 잔여면 조회'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },
];

export default periodRoutes;
